@if (resolvedSiteId(); as siteId) {

  <div class="planning__card">
    <app-planning-controls
      [mode]="mode()"
      [colorBy]="colorBy()"
      [timeScale]="timeScale()"
      [monthOptions]="monthOptions()"
      [monthId]="monthId()"
      [primaryColorByLabel]="primaryColorByLabel()"
      [reportDisabled]="reportDisabled()"
      (reportClick)="deliveryPlanning()?.openReport()"
      (modeChange)="setMode($event)"
      (colorByChange)="onColorByChange($event)"
      (timeScaleChange)="onTimeScaleChange($event)"
      (monthChange)="onMonthChange($event)"
      (todayClick)="onToday()"
      (navigate)="onNavigate($event)" />

    @if (mode() === 'drilling') {
      <app-drill-planning
        [siteId]="siteId"
        [colorBy]="colorBy()"
        [timeScale]="timeScale()"
        [bounds]="bounds()" />
    } @else {
      <app-delivery-planning
        [siteId]="siteId"
        [colorBy]="colorBy()"
        [timeScale]="timeScale()"
        [bounds]="bounds()" />
    }
  </div>

} @else {
  <div class="planning__placeholder">{{ 'PLANNING.NO_SITE_SELECTED' | translate }}</div>
}
